<template>
  <div class="fill-height phone_settings">
    <v-card class="fill-height">
      <v-card-title style="padding: 0px">
        <v-toolbar grey flat>
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-4">
          <v-list>
            <v-list-item @click="account_dialog = true">
              <v-list-item-icon>
                <v-icon>fas fa-user</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Account</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-if="current_user.stripe_customer_id"
                link
                :href="'/api/subscription/portal/user/' + current_user.id"
                target="_blank"
            >
                <v-list-item-icon>
                    <v-icon>fas fa-file-invoice-dollar</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ $t("common.billing") }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- 
            <v-list-item>
              <v-list-item-icon>
                <v-icon>fas fa-question-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Help and Support</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            -->

            <v-list-item link @click="calibration_dialog_model = true">
            <v-list-item-icon>
              <v-badge
                v-if="current_calibration"
                small
                overlap
                bordered
                color="success"
                icon="check"
              >
                <v-icon>settings</v-icon>
              </v-badge>
              <v-badge
                v-else
                small
                overlap
                bordered
                color="warning"
                icon="fas fa-exclamation"
              >
                <v-icon>settings</v-icon>
              </v-badge>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                $t("main_menu.calibrate")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>fas fa-sign-out-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
      </v-card-text>
    </v-card>

    <!-- User Account dialog -->
    <v-dialog v-model="account_dialog" fullscreen>
      <UserEdit v-if="account_dialog" :user="current_user" :show_logout="false" :limit_collection="false" :show_user_subscriptions="false" @close-user-account="account_dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

import UserEdit from "../../shared/components/UserEdit.vue";
import { logout_helpscout } from "../../shared/lib/helpscout";

export default {
  components: {
    UserEdit,
  },
  data() {
    return {
      account_dialog: false,
    };
  },
  computed: {
    ...mapState(["current_user", "current_calibration", "calibration_dialog", "masquerade"]),
    calibration_dialog_model: {
      set(val) {
        this.$store.commit("setCalibrationDialog", val);
      },
      get() {
        return this.$store.state.calibration_dialog;
      },
    },
  },
  methods: {
    logout: function () {
      logout_helpscout();

      if (this.masquerade) {
        axios.post("/api/user/unmasquerade").then((response) => {
          let resp = response.data;
          if (resp.status == "success") {
            window.location.reload();
          } else {
            messageBus.$emit("api-error", resp);
          }
        });
      } else {
        axios.post("/api/user/logout").then((response) => {
          let resp = response.data;
          if (resp.status == "success") {
            window.location.reload();
          } else {
            messageBus.$emit("api-error", resp);
          }
        });
      }
    },
  },
};
</script>

<style>
.phone_settings .v-list-item {
  border-bottom: 1px solid #eee;
}
</style>
